module.exports = __webpack_public_path__ + "img/logo.1779bc54.png";